import { useState, useRef } from 'react'
import './RemoveVocals.css';

import Slider from '@material-ui/core/Slider';
import YunSection from '../YunSection/YunSection';
import YunIcon from '../YunIcon/YunIcon';

import { openWindow } from '../../../utils/index';

const RemoveVocals = function(props) {
    const { pageset, vocalsValue, updateVocalsValue, vocalsPluginState, setPluginTipDiaState } = props;
    const [valueLabelState, setValueLabelState] = useState("auto");
    const valueLabelTimer = useRef(null);
    const lastCallTime = useRef(0); // 记录上次调用时间
    const sliderConfig = {
        min: 0,
        max: 100,
    }
    const [showMask, setShowMask] = useState(false);
    const [showTipDialog, setShowTipDialog] = useState(false); // 控制提示弹框显示
    const showVal = sliderConfig.max - vocalsValue;
    
    const showPluginTipDia = () => {
        // 节流调用新方法：第一次立即触发，后续5秒内不执行，超过5秒才会执行
        const now = Date.now();
        if (now - lastCallTime.current > 5000) {
            // 超过3秒或第一次调用，立即执行
            setPluginTipDiaState({
                isVisible: true,
                pluginName: "消人声"
            })
            lastCallTime.current = now;
        }
    }

    const handleChangeVocals = (value) => {
        showPluginTipDia()
        if (!vocalsPluginState.length) {
            setShowMask(true)
            setTimeout(() => {
                setShowMask(false)
            }, 5000);
            return false
        }
        updateVocalsValue(sliderConfig.max - value);
    }
    const clickChangeVocals = (value) => {
        let val = showVal + value;
        if (val > sliderConfig.max) val = sliderConfig.max;
        if (val < sliderConfig.min) val = sliderConfig.max;
        handleChangeVocals(val);
        if (valueLabelTimer.current) {
            clearTimeout(valueLabelTimer.current);
        }
        setValueLabelState("on");
        valueLabelTimer.current = setTimeout(() => {
            setValueLabelState("auto");
        }, 2000);
    }
    const formatText = (val) => {
        if (val < 50) {
            return `伴奏-${50 - val}`
        } else if (val > 50) {
            return `人声-${val - 50}`
        } else {
            return 0
        }
    }
    const doubleClickTo0 = (e) => {
        e.stopPropagation();
        e.preventDefault();
        handleChangeVocals(50);
    }
    // 跳转到升降调设置页面
    function clickToSettingPage() {
        openWindow(window.location.origin + window.location.pathname + '#/vocals');
    }
    if (!pageset.vocals) {
        return null;
    }
    return (
        <div className="RemoveVocals YunComponent">
            <YunSection width="200" height="27">
                <div className="VocalsContent">
                    <div onClick={() => clickChangeVocals(-1)} className="VocalsBtn">
                        <div className="Label">消伴奏</div>
                        <YunIcon className="MainColor" icon="left"></YunIcon>
                    </div>
                    <Slider
                        valueLabelDisplay={valueLabelState}
                        value={showVal}
                        valueLabelFormat={formatText}
                        onChange={(e, value) => handleChangeVocals(value)}
                        onDoubleClick={doubleClickTo0}
                        min={sliderConfig.min}
                        max={sliderConfig.max} >
                    </Slider>
                    <div onClick={() => clickChangeVocals(1)} className="VocalsBtn">
                        <YunIcon className="MainColor" icon="right"></YunIcon>
                        <div className="Label">消人声</div>
                    </div>
                </div>
                {/* 酷狗音效提示弹框 */}
                {showTipDialog && (
                    <div className="TipDialog">
                        <div className="TipDialogContent">
                            <div className="TipText">检测到酷狗音效已开启，消人声效果可能不生效</div>
                            <div className="TipClose" onClick={() => setShowTipDialog(false)}>×</div>
                        </div>
                    </div>
                )}
                <div className="VocalsContentEnd">
                </div>
                <div className={showMask ? 'Mask Active' : 'Mask'} onClick={clickToSettingPage}>
                    <div className="MaskText">
                        <span className="UnderlineAnimation HoverColor MainColor">未连接</span>
                        <span>消人声插件 </span>
                        <YunIcon icon="click" iconClass="HoverColor MainColor"></YunIcon>
                        <span>设置</span>
                    </div>
                </div>
            </YunSection>
        </div>
    )
}

export default RemoveVocals;
